<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="denominations"
	[paginator]="denominations && denominations.length > 10"
	[rows]="10"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[10, 25, 50]"
	[globalFilterFields]="['promoCode']"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="d-flex">
				<div class="mx-2 mt-3">Allow Custom Amounts</div>
				<div class="mx-2 mb-3 mt-3">
					<p-inputSwitch *ngIf="eGiftVenue" [(ngModel)]="eGiftVenue.customAmount"> </p-inputSwitch>
				</div>
			</div>
			<div class="d-flex ms-auto">
				<app-record-control-footer
					[hideAdd]="false"
					[hideCancel]="true"
					[hideDelete]="true"
					[hideSave]="true"
					(onAddChange)="new()"
				></app-record-control-footer>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th>Value</th>
			<th>Amount</th>
			<th>Prefix</th>
			<th>Promo Expire Date</th>
			<th>Active</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr (click)="denominationSelected = rec">
			<td>{{ rec.value | currency }}</td>
			<td>
				{{ rec.amount | currency }}
			</td>
			<td>
				{{ rec.prefix }}
			</td>
			<td>
				<span *ngIf="rec.expirationDate">{{ moment(rec.expirationDate).format("l LT") }}</span>
			</td>
			<td>
				<p-inputSwitch [disabled]="true" [(ngModel)]="rec.active"></p-inputSwitch>
			</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog *ngIf="denominationSelected" header="EGift Denomination" [(visible)]="denominationSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }">
	<div class="d-flex flex-column">
		<div class="d-flex">
			<p-inputSwitch [(ngModel)]="denominationSelected.active"></p-inputSwitch>
			<div class="mx-auto ms-1">Active</div>
		</div>

		<p-inputNumber
			placeholder="Card Value $"
			[(ngModel)]="denominationSelected.value"
			inputId="currency-us"
			mode="currency"
			currency="USD"
			locale="en-US"
			styleClass="w-100 m-2"
		></p-inputNumber>
		<p-inputNumber
			placeholder="Purchase Amount $"
			[(ngModel)]="denominationSelected.amount"
			inputId="currency-us"
			mode="currency"
			currency="USD"
			locale="en-US"
			styleClass="w-100 m-2"
		></p-inputNumber>
		<input pInputText type="text" placeholder="Offer Prefix" name="prefix" [(ngModel)]="denominationSelected.prefix" max="15" class="w-100 m-2" />
		<p-calendar
			placeholder="Expiration Date"
			inputId="basic"
			showIcon="true"
			[(ngModel)]="denominationSelected.expirationDate"
			styleClass="w-100 m-2"
			appendTo="body"
		></p-calendar>
	</div>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]="false"
			[hideDelete]="false"
			[hideSave]="false"
			(onCancelChange)="denominationSelected = undefined"
			(onDeleteChange)="deleteDenomination(denominationSelected)"
			(onSaveChange)="save(denominationSelected)"
			[deleteDisabled]="denominationSelected.unsaved"
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
